var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.509,148.692l19.51,-45.805l-18.416,8.353l0,-111.24l-2.187,0l0,111.24l-18.416,-8.353l19.509,45.805"}));
}

ArrowDownInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 40 149","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"className":"ark-svg"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
